import { useEffect, useReducer } from "react";
import { removeEmptyVals } from "../helpers/helper";
import Request from "../helpers/request.service";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "loading":
      return { ...state, loading: action.payload };
    case "data":
      return { ...state, data: action.payload };
    case "error":
      return { ...state, error: action.payload };
    case "reset":
      return initialState;
    default:
      return state;
  }
};

export const useFetch = ({
  url = "",
  config = {},
  skip = false,
  dependencyList = [],
  onCompleted = null,
  onError = null,
  requestFn = null,
} = {}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const fetchData = async (
    runQueryURL = null,
    runQueryConfig = null
    // runQueryApiCode = null
  ) => {
    dispatch({ type: "reset", payload: null });
    dispatch({ type: "loading", payload: true });

    try {
      const filteredParams = removeEmptyVals(runQueryConfig || config);
      const params = new URLSearchParams(filteredParams).toString();
      const res = requestFn
        ? await requestFn(runQueryURL || url, filteredParams, runQueryConfig || config)
        : await Request.get(runQueryURL || url, params);
      dispatch({ type: "data", payload: res?.data });
      if (onCompleted) {
        const returnedState = onCompleted(res);
        if (returnedState) {
          dispatch({ type: "data", payload: returnedState });
        }
      }
      dispatch({ type: "loading", payload: false });
      return res;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.detail?.message ||
        error?.response?.data?.message ||
        error?.response?.statusText ||
        error?.message ||
        "An unknown error occurred";

      dispatch({ type: "error", payload: errorMessage });
      dispatch({ type: "loading", payload: false });
      onError && onError(errorMessage);
      console.log(error);
    }
  };

  useEffect(() => {
    if (url && url !== "" && !skip) {
      fetchData();
    }
  }, [skip, url, ...dependencyList]);

  return { ...state, runQuery: fetchData };
};
